module.exports = __webpack_public_path__ + "img/creditcard-back.dba64aef.png";